
import { ref } from 'vue';
import { useStore } from 'vuex';

// nanoid
import { nanoid } from 'nanoid';

// enums
import { TodosMutationTypes } from '@/models/todos';

export default {
  name: 'FormInput',
  setup() {
    const store = useStore();

    const contentRef = ref<string>('');
    const inputRef = ref<HTMLElement>(null!);

    const handleAddTodo = (content: string) => {
      inputRef.value.focus();

      if (!content) return;

      store.commit(TodosMutationTypes.ADD_TODO, {
        id: nanoid(),
        content: content,
        completed: false,
      });
      store.commit(TodosMutationTypes.SET_STATUS, 'all');

      contentRef.value = '';
    };

    return { contentRef, inputRef, handleAddTodo };
  },
};
